import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { create } from "zustand";

import RootPage from "./pages";
import ContextPage from "./pages/users";

type LogoutTrackerState = {
  logoutHasStarted: boolean;
  startLogout: () => void;
};

export const useLogoutTracker = create<LogoutTrackerState>(set => ({
  logoutHasStarted: false,
  startLogout: () => set(() => ({ logoutHasStarted: true })),
}));

function App() {
  const { isLoading, isAuthenticated, login } = useKindeAuth();
  const logoutHasStarted = useLogoutTracker(state => state.logoutHasStarted);

  useEffect(() => {
    if (isLoading || isAuthenticated || logoutHasStarted) {
      return;
    }

    (async (): Promise<void> => {
      await login();
    })();
  }, [isLoading, isAuthenticated, login]);

  if (!isAuthenticated || isLoading) {
    return;
  }

  return (
    <Routes>
      <Route path="/" element={<RootPage />} />
      <Route path="/users" element={<ContextPage />} />
    </Routes>
  );
}

export default App;
